import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { ProcessState } from '../../../../types/processes/processTypes';
import useTranslate from '../../../../customHooks/useTranslate';

interface ProcessItemProps {
    process: ProcessState;
}

/**
 * Displays an active process name and indeterminate activity indicator.
 * @param props.process The process to display.
 * @returns The process content for an activity list item.
 */
const ProcessItem = ({ process }: ProcessItemProps) => {
    const translate = useTranslate();
    const label = `${translate('process')} #${process.idProcess}`;

    return (
        <Box className='activity__process-item'>
            <Box className='activity__process-header'>
                <Typography variant='body2' className='activity__process-name'>
                    {process.name}
                </Typography>
            </Box>
            <Box className='activity__process-progress'>
                <LinearProgress
                    variant='indeterminate'
                    aria-label={label}
                    className='activity__process-bar'
                />
            </Box>
        </Box>
    );
};

export default ProcessItem;
